import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// Component
import { PublicidadComponent } from './publicidad/publicidad.component';
import { MediaComponent } from './media/media.component';
import { ReelsComponent } from './reels/reels.component';
import { UnitsComponent } from './units/units.component';
import { GroupsComponent } from './groups/groups.component';
import { ReelCategoriesComponent } from './reel-categories/reel-categories.component';
import { EvidencesComponent } from './evidences/evidences.component';
import { LayoutsComponent } from './layouts/layouts.component';
import { UsersComponent } from './users/users.component';
import { RolesGuard } from '../../../guards/roles.guard';
import { MediaKpiComponent } from './media-kpi/media-kpi.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'media',
    pathMatch: 'full'
  },
  {
    path: 'media',
    component: MediaComponent,
    canActivate: [RolesGuard],
    data: {
      title: 'Media'
    }
  },
  {
    path: 'reels',
    component: ReelsComponent,
    canActivate: [RolesGuard],
    data: {
      title: 'Reels'
    }
  },
  {
    path: 'reels/:id',
    component: ReelsComponent,
    canActivate: [RolesGuard],
    data: {
      title: 'Reels'
    }
  },
  {
    path: 'units',
    canActivate: [RolesGuard],
    component: UnitsComponent,
    data: {
      title: 'Unidades'
    }
  },
  {
    path: 'groups',
    component: GroupsComponent,
    canActivate: [RolesGuard],
    data: {
      title: 'Grupo de Unidades'
    }
  },
  {
    path: 'reel-categories',
    component: ReelCategoriesComponent,
    canActivate: [RolesGuard],
    data: {
      title: 'Categorias de Reels'
    }
  },
  {
    path: 'reel-evidences/:id',
    component: EvidencesComponent,
    canActivate: [RolesGuard],
    data: {
      title: 'Evidencias de Reels'
    }
  },
  {
    path: 'layouts',
    component: LayoutsComponent,
    canActivate: [RolesGuard],
    data: {
      title: 'Layouts'
    }
  },
  {
    path: 'media-kpi',
    component: MediaKpiComponent,
    canActivate: [RolesGuard],
    data: {
      title: 'Estadisticas'
    }
  },
  {
    path: 'usuarios',
    component: UsersComponent,
    canActivate: [RolesGuard],
    data: {
      title: 'Usuarios'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SvsRoutingModule { }
